/**
 * @generated SignedSource<<c98385b22800ebd7c67e91b0eb36c03b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GetVideoDataV2Input = {
  clientMutationId?: string | null | undefined;
  vimeoId: string;
  vimeoVideoSourceId: string;
};
export type VimeoPodcastSourceField_GetVideoDataV2Mutation$variables = {
  input: GetVideoDataV2Input;
};
export type VimeoPodcastSourceField_GetVideoDataV2Mutation$data = {
  readonly Admin: {
    readonly ElearningV2: {
      readonly getVideoData: {
        readonly videoData: {
          readonly duration: number;
          readonly name: string;
          readonly thumbnailUrl: string;
        } | null | undefined;
      } | null | undefined;
    };
  };
};
export type VimeoPodcastSourceField_GetVideoDataV2Mutation = {
  response: VimeoPodcastSourceField_GetVideoDataV2Mutation$data;
  variables: VimeoPodcastSourceField_GetVideoDataV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ElearningV2AdminMutationSchema",
        "kind": "LinkedField",
        "name": "ElearningV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "GetVideoDataV2Payload",
            "kind": "LinkedField",
            "name": "getVideoData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoDataV2",
                "kind": "LinkedField",
                "name": "videoData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duration",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnailUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VimeoPodcastSourceField_GetVideoDataV2Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VimeoPodcastSourceField_GetVideoDataV2Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3cc7bf005289cb129e6cab7b3be4f272",
    "id": null,
    "metadata": {},
    "name": "VimeoPodcastSourceField_GetVideoDataV2Mutation",
    "operationKind": "mutation",
    "text": "mutation VimeoPodcastSourceField_GetVideoDataV2Mutation(\n  $input: GetVideoDataV2Input!\n) {\n  Admin {\n    ElearningV2 {\n      getVideoData(input: $input) {\n        videoData {\n          name\n          duration\n          thumbnailUrl\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4746099a1905093b683b365d2c9ef2c";

export default node;
